import {makeStyles} from '@material-ui/core';
import React, {FC} from 'react';

const useComponentStyles = makeStyles({
    about: {
        fontSize: '150%',
        padding: '20px 10%',
    }
});

const About: FC = () => {
    const styles = useComponentStyles();
    return (
        <article className={styles.about}>
            <h1>О конструкторе игр</h1>
            <p>В рамках программы по развитию и внедрению ассистивных технологий для детей с тяжелыми и множественными
                нарушениями развития Центр “Пространство общения” разработал веб-конструктор простых развивающих игр для
                детей с особыми потребностями. Родители или специалисты могут самостоятельно создавать для ребенка игры,
                которые помогают освоить понимание причинно-следственных связей и идею выбора. В играх можно
                использовать те аудио- и фотоматериалы, которые привычны и интересны конкретному ребенку.
                Зарегистрировавшись в личном кабинете, вы можете создавать свои игры в неограниченном количестве и
                сохранять их.
            </p>
            <p>1. В базовой игре <b>на установление причинно-следственных связей </b>специалист или родитель загружает
                фотографию/картинку и мелодию. Ребенку предлагается нажать на кружок на экране (нажатие можно произвести с
                помощью выносной кнопки, переключателя, адаптированной мышки, тачскрина или айтрекера). После этого
                появляется экран с загруженной фотографией или картинкой и начинает звучать мелодия. В одну игру можно
                загрузить сразу несколько картинок и мелодий, тогда они будут чередоваться. Можно выставить определенное
                время звучания мелодии. После окончания установленного времени возвращается начальный экран игры. Чтобы
                сыграть в нее снова, нужно опять нажать/посмотреть на кружочек.</p>

            <p>Таким образом, игра позволяет ребенку понять, что от его определенного действия зависит то, что произойдет
                дальше, т.е. осознать причинно-следственную связь между собственным действием и результатом, почувствовать
                свое влияние на окружающий мир.</p>

            <p>2. <b>Игра на выбор</b> из двух позволяет загрузить мелодии и картинки так, что перед ребенком оказываются два
                кружочка - с двумя разными картинками, из которых он может выбрать один по своему предпочтению. Кружочкам
                можно присвоить разные цвета, чтобы они соотносились с выносными кнопками, с помощью которых ребенок может
                управлять игрой. Например, если левая кнопка - синяя, а правая - красная, такие же цвета можно назначить
                кружочкам, обрамляющим загруженные картинки.
                Клавиша “пробел” отвечает за переключение между кружочками, а “энтер” осуществляет выбор (соответственно, их
                нужно вывести в выносные кнопки, если ребенок пользуется ими; и, конечно, здесь тоже доступно управление с
                помощью айтрекера).
                После нажатия картинка увеличивается и звучит мелодия.</p>

            <p>3. <b>Игра на выбор из трех и более</b> - усложненная версия игры на выбор из двух. Возможности остаются теми же,
                но родитель/специалист здесь может загрузить три и более наборов картинок+мелодий и предложить ребенку
                выбирать среди них.</p>

            <p><i>Веб-конструктор разработан в рамках проекта “Мастерская ассистивных технологий”, поддержанного Фондом
                президентских грантов</i></p>.

        </article>
    )
}

export default About;
